import router from "@/plugins/router";
import store from "@/store";
import i18n from '@/plugins/i18n';
import { getErrorString, getHttpErrorString, getBuypassErrorString } from "@nifnpm/vue-error-utils";

export const determineRedirectOnError = async function (error, text) {
    if (error?.isAxiosError && error?.config.method === "get" && error?.request.status > 0) {
        await store.commit("errorStore/set", text);
        router.push("/error");
        return true;
    }

    return false;
};

export const handleError = async function (error) {
    const text = getErrorString(error, i18n.global, [getBuypassErrorString, getHttpErrorString]);

    if (await determineRedirectOnError(error, text)) {
        return;
    }

    store.commit("snacksStore/add", [text, "error"]);
};